module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-about-69c157911acc176b02e40aa357aca3e8.svg&quot;;"